import { render } from "./VersionListTemplate.vue?vue&type=template&id=cd42ecc8&scoped=true"
import script from "./VersionListTemplate.vue?vue&type=script&lang=js"
export * from "./VersionListTemplate.vue?vue&type=script&lang=js"

import "./VersionListTemplate.vue?vue&type=style&index=0&id=cd42ecc8&scoped=true&lang=css"

import exportComponent from "D:\\agents\\Oreo\\_work\\93\\s\\NcasReporting\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd42ecc8"]])

export default __exports__